import axios from '@/libs/http'
import {appendIfNotEmpty} from "@/libs/util";


/**
 * 兑换奖品
 */
export const exchangePrize = (id,userId) => {
    let data = new URLSearchParams()
    data.append("id",id);
    appendIfNotEmpty(data,'userId',userId)
    return axios.request({
        url: '/s/c/clerk-point-prize/exchangePrize',
        data,
        method: 'post'
    })
}



/**
 * 奖品列表
 */
export const getPointPrizeList = (id,action,pageNo, pageSize) => {
    let data = new URLSearchParams()
    appendIfNotEmpty(data,'id',id)
    appendIfNotEmpty(data,'action',action)
    data.append("pageNo",pageNo);
    data.append("pageSize",pageSize);
    return axios.request({
        url: '/s/c/clerk-point-prize/list',
        data,
        method: 'post'
    })
}

